var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgQuote = function SvgQuote(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 59.762 51.276"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 140",
    d: "M3.611 51.276C20.222 51.1 24.735 40.8 25.46 20.041c.181-5.958.361-12.819.361-20.041H0v25.819h12.46c0 9.389-1.625 16.069-11.014 16.25Zm33.943 0C54.165 51.1 58.679 40.8 59.401 20.041c.181-5.958.359-12.819.359-20.041H33.943v25.819h12.458c0 9.389-1.625 16.069-11.014 16.25Z",
    fill: "currentColor"
  })));
};
export default SvgQuote;